import { useEffect, useRef, useState } from 'react'

const useClickOutsideToggle = () => {
    const [expanded, setExpanded] = useState(false)
    const ref = useRef(null)
    useEffect(() => {
    const handleClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
            setTimeout(() => setExpanded(false), 10); // Small delay ensures clean transition
        }
    };
    document.addEventListener("mouseup", handleClickOutside);
    
    return () => {
        document.removeEventListener("mouseup", handleClickOutside);
    };
}, [ref]);

  return {expanded, setExpanded, ref}
}

export default useClickOutsideToggle